function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.667 4.667c.916 0 1.666-.75 1.666-1.667s-.75-1.667-1.666-1.667C6.75 1.333 6 2.083 6 3s.75 1.667 1.667 1.667zM7.667 6.333C6.75 6.333 6 7.083 6 8s.75 1.667 1.667 1.667c.916 0 1.666-.75 1.666-1.667s-.75-1.667-1.666-1.667zM7.667 11.333C6.75 11.333 6 12.083 6 13s.75 1.667 1.667 1.667c.916 0 1.666-.75 1.666-1.667s-.75-1.667-1.666-1.667z",
  stroke: "#666A72",
  strokeLinecap: "round"
});

var SvgMoreVert = function SvgMoreVert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default SvgMoreVert;